import React, { useEffect, useState, useCallback } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import ErrorSoundFile from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import SymbolCard from "./SymbolCard";
import moment from "moment";
import TopHeader from "./TopHeader";

const backend = await new Backend().init();

export default function SymbolLogs() {
  const [playError] = useSound(ErrorSoundFile);
  const windowSize = useSize();

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Load Logs
  const loadLogs = useCallback(
    async (startDate, endDate) => {
      setLoading(true);

      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        start: startDate ?? moment().startOf("week"),
        end: endDate ?? moment().endOf("week"),
      };

      try {
        const res = await backend.symbol_rejection(data);
        if (res.error === "False") {
          setLogs(res.rejection || []);
        } else {
          playError();
          toast.error(res.message || "Failed to load logs.");
        }
      } catch (err) {
        playError();
        toast.error("Something went wrong while loading symbol logs.");
      } finally {
        setLoading(false);
      }
    },
    [playError]
  );

  // 🔹 On Mount
  useEffect(() => {
    loadLogs();
  }, [loadLogs]);

  return (
    <div
      className="flex flex-col"
    >
      {/* Header */}
      <TopHeader loadLogs={loadLogs} />

      {/* Main Content */}
      <div className="flex-1 px-3 pb-3">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <Loading height={windowSize[1] - 80} />
          </div>
        ) : logs.length > 0 ? (
          <div
            style={{
              height: windowSize[1] - 80,
              overflowY: "auto",
            }}
            className="flex flex-col gap-3"
          >
            {logs.map((item) => (
              <SymbolCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            small
            height={windowSize[1] - 80}
            title="Nothing here"
            subtext="No Symbol Logs Found."
          />
        )}
      </div>
    </div>
  );
}
